/** Save control for the spread flow. Presentational: the flow owns the save
 *  itself, so a click and an automatic save on step change report through the
 *  same status line. */
import React from 'react';
import { CRC } from './moduleInputsData';

export type SaveStatus =
  | { status: 'idle' | 'saving' }
  | { status: 'saved'; at: string }
  | { status: 'error'; message: string };

interface Props {
  state: SaveStatus;
  onClick: () => void;
  label: string;
}

const button = (disabled: boolean): React.CSSProperties => ({
  width: '100%', padding: '9px 12px', borderRadius: 8, border: 'none',
  background: disabled ? CRC.pageBg : CRC.readableRed, color: disabled ? CRC.heritageGrey : '#fff',
  fontWeight: 600, fontSize: 13, fontFamily: 'inherit', cursor: disabled ? 'default' : 'pointer',
});
const note = (color: string): React.CSSProperties => ({ fontSize: 10.5, color, marginTop: 5 });

export const SpreadSaveButton: React.FC<Props> = ({ state, onClick, label }) => {
  const busy = state.status === 'saving';
  return (
    <div style={{ marginBottom: 8 }}>
      <button onClick={onClick} disabled={busy} style={button(busy)}>
        {busy ? 'Saving…' : label}
      </button>
      {state.status === 'saved' && <div style={note(CRC.blueprintBlue)}>Saved {state.at}</div>}
      {state.status === 'error' && <div style={note(CRC.readableRed)}>{state.message}</div>}
    </div>
  );
};
